G.BoardConcrete =  function(board) {
  G.BoardLayer.call(this, board, {
    constructor: G.Concrete,
    maxHp: 3,
    hpToken: true,
    editorSymbol: "cn",
    blockMove: true,
    blockBoosterChange: true,
    collectableType: "concrete",
    stopMatchPropagation: true,
    stopHitPropagation: true,
  });
};

G.BoardConcrete.prototype = Object.create(G.BoardLayer.prototype);